<template>
    <div>
        <h1>抽選会参加登録</h1>
        <v-container>
            <v-card>
                <v-card-title>{{ eventName }}</v-card-title>
            </v-card>
        </v-container>
        <v-card-title>参加登録</v-card-title>
        <v-form>
            <v-text-field placeholder="name" v-model="participant.name"></v-text-field>
            <v-alert v-if="error" type="error" dismissible>{{ error }}</v-alert>
            <v-btn @click="addItem">登録</v-btn>
        </v-form>
    </div>
</template>
<script>
    import firebase from 'firebase'
    export default {
        data() {
            return {
                userId: "",
                eventId: "",
                eventName: "",
                participant: {
                    name: "",
                },
                error: ""
            }
        },
        methods: {
            addItem: async function() {
                console.log("add item")
                this.error = ""
                const db = firebase.firestore()
                const userRef = db.collection("users").doc(this.$route.params.userId)
                const eventRef = userRef.collection("events").doc(this.$route.params.eventId)
                const participantsRef = eventRef.collection("participants")

                // TODO同名チェック
                const check = await participantsRef.where("name", "==", this.participant.name).get()
                if(check.size != 0){
                    this.error = "すでに同名で登録されています"
                    return
                }

                const participantRef = participantsRef.doc()
                participantRef.set({
                    name: this.participant.name,
                    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
                })
                // 参加者ページに移動
                this.$router.push({name: 'participant', params: {eventId: this.eventId, participantId: participantRef.id}})
            }
        },
        async mounted() {
            const db = firebase.firestore()
            const userRef = db.collection("users").doc(this.$route.params.userId)
            const eventRef = userRef.collection("events").doc(this.$route.params.eventId)
            this.eventId = eventRef.id
            const eventData = await eventRef.get()
            this.eventName = eventData.data().name
        }
    }

</script>